const Icon = (props) => {
    return (
        <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.444 1H2.778A1.778 1.778 0 001 2.778v2.666m16 0V2.778A1.778 1.778 0 0015.222 1h-2.666m0 16h2.666A1.778 1.778 0 0017 15.222v-2.666m-16 0v2.666A1.778 1.778 0 002.778 17h2.666"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
